import {
  LayoutDashboard,
  ChartSpline,
  Settings2,
  FolderKanban,
  Sparkles,
  DollarSign,
} from "lucide-react";
import type { NavItem } from "@/types/nav";

export const homeOwnerNav: NavItem[] = [
  {
    title: "Dashboard",
    url: "/dashboard/home-owner/dashboard/overview",
    icon: LayoutDashboard,
  },
  {
    title: "Manage",
    url: "/dashboard/home-owner/manage",
    icon: FolderKanban,
    items: [
      {
        title: "Properties",
        url: "/dashboard/properties/manage-homes",
      },
      {
        title: "Services",
        url: "/dashboard/properties/manage-services",
      },
      {
        title: "Work Orders",
        url: "/dashboard/work-orders",
      },
    ],
  },
  {
    title: "Financials",
    url: "/dashboard/home-owner/financials",
    icon: DollarSign,
    items: [
      {
        title: "Activity",
        url: "/dashboard/home-owner/financials/activity",
      },
      {
        title: "Funding",
        url: "/dashboard/company/funding-history",
      },
      // Hidden intentionally for home_owner on 2026-02-20 - DO NOT DELETE
      // {
      //   title: "Reconciliation",
      //   url: "/dashboard/company/accounting-statements",
      // },
      {
        title: "Invoices",
        url: "/dashboard/home-owner/financials/invoices",
      },
      {
        title: "Fees",
        url: "/dashboard/home-owner/financials/fees",
      },
    ],
  },
  // Transactions section removed for home_owner on 2026-01-16 - moved to Financials
  // Hidden items: Declined, Adjustments - DO NOT DELETE
  {
    title: "Reports",
    url: "/dashboard/reports",
    icon: ChartSpline,
    items: [
      // {
      //   title: "Tenants",
      //   url: "/dashboard/reports/onboarding-tenants",
      // },
      {
        title: "Statements",
        url: "/dashboard/reports/statements",
      },
      {
        title: "Service Trends",
        url: "/dashboard/reports/service-trends",
      },
      {
        title: "Missing Services",
        url: "/dashboard/reports/missing-services",
      },
      // Hidden intentionally for home_owner on 2026-01-16 - DO NOT DELETE
      // {
      //   title: "Active Services",
      //   url: "/dashboard/reports/active-services",
      // },
      // Hidden intentionally for home_owner on 2026-01-17 - DO NOT DELETE
      // {
      //   title: "Statements",
      //   url: "/dashboard/reports/statements",
      // },
      // Hidden intentionally for home_owner on 2026-01-16 - DO NOT DELETE
      // {
      //   title: "Bill Pay",
      //   url: "/dashboard/reports/bill-pay",
      // },
      // {
      //   title: "Bill Back",
      //   url: "/dashboard/reports/bill-back",
      // },
      {
        title: "Spikes",
        url: "/dashboard/reports/spikes",
      },
      // {
      //   title: "Collections",
      //   url: "/dashboard/reports/collections",
      // },
      // {
      //   title: "Deposits",
      //   url: "/dashboard/reports/deposits",
      // }
      // Monthly Settlements moved to Financials section on 2026-02-02
    ],
  },
  // Hidden intentionally for home_owner on 2026-02-20 - DO NOT DELETE
  // {
  //   title: "AI Tools",
  //   url: "/dashboard/ai-tools",
  //   icon: Sparkles,
  //   items: [
  //     {
  //       title: "Fee Analyzer",
  //       url: "/dashboard/ai-tools/fee-analyzer",
  //     },
  //   ],
  // },
  {
    title: "Settings",
    url: "/dashboard/settings",
    icon: Settings2,
    items: [
      {
        title: "Company Information",
        url: "/dashboard/settings/company",
      },
      // Hidden intentionally for home_owner on 2026-01-16 - DO NOT DELETE
      // {
      //   title: "Bank Accounts",
      //   url: "/dashboard/settings/bank",
      // },
      {
        title: "Spike Alert Thresholds",
        url: "/dashboard/settings/spike-alert",
      },
      // Hidden intentionally for home_owner on 2026-01-16 - DO NOT DELETE
      // {
      //   title: "Payment Settings",
      //   url: "/dashboard/settings/payments",
      // },
      {
        title: "Notifications",
        url: "/dashboard/settings/notifications",
      },
    ],
  },
];
